import { injectable } from 'inversify';
import type { IChannel, IChannelSettings } from './types';

@injectable()
class Channel implements IChannel {
  protected _Name: string;

  constructor(settings: IChannelSettings) {
    this._Name = settings.name;
  }

  getName(): string {
    return this._Name;
  }

  getNamespace(): string {
    return this._Name;
  }
}

export default Channel;
